/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import { providers } from "dc-core";
import { VERB_ORGANIZE_ROTATE } from "constants/enums";
import RotateCW from "dc-icons/viewer2021/SDC_RotateCW_18_N.svg";
import RotateCCW from "dc-icons/viewer2021/SDC_RotatePagesCCW_18_N.svg";
import * as constants from "constants/constants";
import * as stores from "stores";
import { handleCCWRotateClick, handleCWRotateClick } from "./utils/OrganizeUtils";

class OrganizeRotateBootstrap extends Component {
  getLabel = () => {};

  getIcon = opts => (opts && opts.context === "CW" ? RotateCW : RotateCCW);

  getTooltip = opts =>
    opts && opts.context === "CW"
      ? getMessage("tooltip.rotate.clockwise")
      : getMessage("tooltip.rotate.counterclockwise");

  getAriaLabel = opts =>
    opts && opts.context === "CW"
      ? getMessage("arialabel.rotate.clockwise")
      : getMessage("arialabel.rotate.counterclockwise");

  getTooltipPlacement = () => "right";

  getTooltipDelay = () => constants.TOOLTIP_DELAY;

  id = VERB_ORGANIZE_ROTATE;

  initializeAction = () => {};

  executeAction = async (opts = {}) => {
    const editProvider = await providers["edit-provider"]();
    await editProvider?.loadEditModule();
    if (opts && opts.context === "CW") {
      await handleCWRotateClick(stores, opts.pageIndices);
    } else if (opts && opts.context === "CCW") {
      await handleCCWRotateClick(stores, opts.pageIndices);
    }
  };

  render() {
    return null;
  }
}

export default OrganizeRotateBootstrap;
